<template>
  <v-container class="black">
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-img src="imagenes/logo.svg" height="60" width="160" contain></v-img>
      </v-col>
      <v-col cols="12">
        <p
          class="white--text font-weight-bold mb-10 text-center px-3 px-md-12"
          v-html="text"
        ></p>
        <p
          class="white--text font-weight-bold mb-10 text-center px-3 px-md-12"
          v-html="text1"
        ></p>
        <p
          class="white--text font-weight-bold mb-10 text-center px-3 px-md-12"
          v-html="text2"
        ></p>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.customFont {
  font-family: "Eras Medium ITC" !important;
}
</style>
<script>
export default {
  props: ["image"],
  data() {
    return {
      publicPath: process.env.BASE_URL,
      text:
        "Realiza operaciones conforme a la Ley de Organizaciones y Actividades Auxiliares del Crédito, con autorización de la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros, no autorizada por la Secretaría de Hacienda y Crédito Público y sin la supervisión de la Comisión Nacional Bancaria y de Valores, excepto por el contenido del segundo párrafo del artículo 56, Artículo 95 Bis y relacionados de la Ley General de Organizaciones y Actividades Auxiliares del Crédito.",
      text1:
        "IMPULSORA Y FOMENTO ÁLICA, S.A.P.I. DE C.V., SOFOM E.N.R. recibe las consultas, reclamaciones o aclaraciones en su Unidad Especializada de Atención a Usuarios ubicada en Av. Juárez 83 Ote, Col. Centro C.P 63000 Tepic, Nayarit, México. Al correo electrónico ifa_une@capitalica.com.mx ,o teléfono (311) 133 45 29 con atención al Titular de la UNE, en un Horario de 9: 00 am a 2:00 pm y de 4:00 pm a 7:00 de lunes a viernes y de 9:00 am a 2:00 pm los sábados, así como en cualquiera de nuestras sucursales y oficinas.",
      text2:
        "En caso que sus dudas, consultas sobre comisiones para fines informativos, quejas o reclamaciones, no fueran resueltas satisfactoriamente en alguna de nuestras sucursales, podrá acudir a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF), con domicilio San Luis Sur 136, Centro, Código Postal 63000 Tepic, Nayarit, México. Al correo electrónico naycond@condusef.gob.mx, teléfono (01) (311) 133 33 09, (01) (311) 133 33 13 y lada sin costo 01 800 999 8080, o consultar la página electrónica en internet www.condusef.gob.mx",
    };
  },
};
</script>
